export default __webpack_public_path__ + "static/media/host_reconnect_mic.8a66e30c.svg";